import React from 'react';
import './Toast.css';

const ICONS = {
  success: '✓',
  error: '✕',
  warning: '⚠',
  info: 'ℹ'
};

function Toast({ message, type = 'info' }) {
  return (
    <div className={`toast toast-${type}`} role="alert">
      <span className="toast-icon">{ICONS[type] || ICONS.info}</span>
      <span className="toast-message">{message}</span>
    </div>
  );
}

export default Toast;
